import { Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { HiOutlineMap } from "react-icons/hi2";
import FormDialog, { PlainCard } from "../../../../components/FormDialog";
import { setMapDataDialog } from "../../../../app/slices/posSlice";
import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const customIcon = new L.Icon({
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

const PosMapData = (props) => {
  const dispatch = useDispatch();

  const items = useSelector((state) => state.pointOfsales.mapData);

  const handleDialog = () => {
    dispatch(setMapDataDialog());
  };

  return (
    <FormDialog
      open={items.dialog}
      onClose={() => {
        handleDialog();
      }}
      icon={<HiOutlineMap />}
      title="خريطة نقاط البيع"
      maxWidth="lg"
    >
      <PlainCard>
        <Grid container spacing={2}>
          <Grid item xs={12} md={12} height={800} width={800}>
            <MapContainer
              center={[33.325891, 44.47519]}
              zoom={16}
              scrollWheelZoom={true}
            >
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              {items.data
                .filter(
                  (location) =>
                    location.latitude !== null && location.longitude !== null
                )
                .map((location, index) => (
                  <Marker
                    key={index}
                    position={[location.latitude, location.longitude]}
                    icon={customIcon}
                  >
                    <Popup>
                      {location.name} - {location.pos_number}
                    </Popup>
                  </Marker>
                ))}
            </MapContainer>
          </Grid>
        </Grid>
      </PlainCard>
    </FormDialog>
  );
};

export default PosMapData;
